import { schema } from "normalizr";

export const positionSchema = new schema.Entity("positions");

export const categorySchema = new schema.Entity("categories", {
  positions: [positionSchema],
});

export const mealOfferSchema = new schema.Entity("mealOffers");

export const mealSchema = new schema.Entity("meals", { offers: [mealOfferSchema] });

export const menuSchema = new schema.Entity("menus", {
  categories: [categorySchema],
  meals: [mealSchema],
});

export const clientSchema = new schema.Entity("clients");

export const orderSchema = new schema.Entity("orders", { client: clientSchema });

export const corpMenuSchema = new schema.Entity("corpMenu");



// WEBPACK FOOTER //
// ./src/schemas.js